import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import * as ScreenSizes from '../../layout/constants/ScreenSizes';
import { useResponsiveProps } from '../../hooks/useResponsiveProps';
import MediaQuery from '../../layout/components/MediaQuery';
export default function ScreenshotsModalShareButton(_ref) {
  let {
    onClick,
    analyticsId,
    shareUrl
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["onClick", "analyticsId", "shareUrl"]);

  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.MD]: false
    }
  });
  return /*#__PURE__*/_jsxs(UICopyButton, Object.assign({}, rest, {
    onClick: onClick,
    "data-hs-analytics-id": analyticsId,
    value: shareUrl,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "share",
      size: isMobileView ? 'xs' : undefined
    }), /*#__PURE__*/_jsx(MediaQuery, {
      minScreenSize: ScreenSizes.MD,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-common.screenshots.modal.shareButton"
      })
    })]
  }));
}